import { render } from "./QC4.vue?vue&type=template&id=387b926a"
import script from "./QC4.vue?vue&type=script&lang=js"
export * from "./QC4.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/QCCharts/QC4.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "387b926a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('387b926a', __exports__)) {
    console.log('reload')
    api.reload('387b926a', __exports__)
  }
  
  module.hot.accept("./QC4.vue?vue&type=template&id=387b926a", () => {
    console.log('re-render')
    api.rerender('387b926a', render)
  })

}


export default __exports__